import { LinkButton, UIText1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { type SeriaPlusScheme } from 'shared/settings/seriaPlusScheme';

import { LayoutBlock } from '../LayoutBlock';

import { Carousel } from './internal/components/Carousel';

import styles from './SeriaPlus.css';

type SeriaPlusProps = {
  scheme: SeriaPlusScheme;
};

export const SeriaPlus: FC<SeriaPlusProps> = props => {
  const {
    scheme: { media, description, title, sectionTabTitle, watchObjectsLink },
  } = props;

  return (
    <LayoutBlock
      backgroundTheme="black"
      bottomOffset={60}
      id="seria-plus"
      rightAdornment={
        <div className={styles['right-adornment']}>
          <UIText1 color="current_color" data-testid="seria-plus-description">
            {description}
          </UIText1>
        </div>
      }
      sectionTabTitle={sectionTabTitle}
      title={title}
      topOffset={60}
    >
      <div className={styles['container']} data-testid="seria-plus-carousel-container">
        <div className={styles['content']} data-testid="seria-plus-carousel-content">
          <div className={styles['carousel-wrapper']} data-testid="seria-plus-carousel-wrapper">
            <Carousel media={media} />
          </div>
          <div className={styles['link-button-container']} data-testid="seria-plus-carousel-link-button-container">
            <LinkButton
              fullWidth
              data-testid="seria-plus-carousel-link-button"
              href={watchObjectsLink}
              size="M"
              target="_blank"
              theme="stroke_secondary"
            >
              Смотреть проекты серии
            </LinkButton>
          </div>
        </div>
      </div>
    </LayoutBlock>
  );
};
